<template>
    <div class="component-container">
        <div class="py-1">
            <v-icon small>mdi-calendar</v-icon><span class="ml-2">{{ competitionDurationString }}</span>
        </div>
        <div v-if="registrationString" class="py-1">
            <v-icon small>mdi-calendar-plus</v-icon><span class="ml-2">{{ registrationString }}</span>
        </div>
        <div v-if="gameClassNames" :class="textClass">
            <v-icon small>mdi-widgets</v-icon><span class="ml-2">{{ gameClassNames }}</span>
        </div>
        <div v-if="description && !short">
            <v-icon small>mdi-information</v-icon><span v-safe-html="description" class="ml-2"></span>
        </div>
        <div v-if="shortDescription && short" :class="textClass">
            <v-icon small>mdi-information</v-icon><span class="ml-2">{{ shortDescription }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'zoezi-teamsport-competition-info',

    props: {
        competition: {
            type: Object,
            required: true
        },
        //Limit length of description and game class names to two lines and uses short description.
        short: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        gameClassNames() {
            return this.competition.gameclasses?.map(gameclass => gameclass.name).join(', ');
        },
        shortDescription() {
            return this.competition.short_description
        },
        description() {
            return this.competition.description
        },
        competitionDurationString() {
            let start = Date.formatFullShort(this.competition.startDate)
            let end = Date.formatFullShort(this.competition.endDate)
            return start + ' - ' + end
        },
        registrationString() {
            let start = Date.newFull(this.competition.registrationStartDate)
            let end = Date.newFull(this.competition.registrationEndDate)
            let today = Date.newFull(this.$store.state.now30s.clone().yyyymmdd())
            if (start >= today) {
                return this.$translate('Registration opens') + ' ' + Date.formatFullShort(start);
            } else if (end >= today) {
                return this.$translate('Registration closes')  + ' ' + Date.formatFullShort(end);
            } else {
                return this.$translate('Registration closed');
            }
        },
        textClass() {
            return this.short ? "py-1 text-container" : 'py-1'
        }
    }
}
</script>

<style scoped>
.text-container {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
